export const safeDeepUpdate = (
  obj: Record<string, unknown>,
  path: string[] = [],
  value: unknown
): Record<string, unknown> | undefined => {
  if (
    obj === undefined ||
    obj === null ||
    path === undefined ||
    path === null ||
    path.length === 0
  ) {
    return
  }
  const lastKey = path.pop()
  if (!lastKey) return
  const loc = path.reduce<Record<string, unknown>>((acc, cur) => {
    if (acc[cur] === undefined || acc[cur] === null) {
      acc[cur] = {}
    }
    return acc[cur] as Record<string, unknown>
  }, obj)
  loc[lastKey] = typeof value === 'function' ? value(loc[lastKey]) : value
}

export const isObjectEmpty = (value?: unknown): boolean =>
  value === undefined || value === null || Object.keys(value).length === 0
